import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform<T extends { name: string; subMenu?: T[] }>(items: T[], searchTerm: string): T[] {
    if (!items || !searchTerm) {
      return items;
    }

    const flattenArray = (arr: T[]): T[] => {
      const result: T[] = [];

      arr.forEach(item => {
        if (item.subMenu !== undefined) {
          result.push(...flattenArray(item.subMenu));
        }

        result.push(item);
      });

      return result;
    };

    const flatArray = flattenArray(items);
    searchTerm = searchTerm.toLowerCase();
    return flatArray.filter(item => item.name.toLowerCase().includes(searchTerm));
  }
}
